import React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <h1>{`Hi, I'm Aditya`}</h1>
    <p>{`I'm currently doing my PhD at the `}<a parentName="p" {...{
        "href": "http://cds.iisc.ac.in/research/research-areas/"
      }}>{`Computational Data Science department`}</a>{` (formerly Supercomputer Education and Research Centre) Indian Institute of Science.
Working under professor `}<a parentName="p" {...{
        "href": "http://cds.iisc.ac.in/faculty/raha/"
      }}>{`Soumyendu Raha`}</a>{` in the Scientific Computation Lab.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      